(() => {
  const svg = '<svg viewBox="0 0 35.13 95.17" aria-hidden="true" focusable="false"><path d="M0,11.66s5.63,6.94,6.08,8.36.19,55.48.19,55.48c0,0,8.8,9.12,15.14,9.75l13.11-14.38-.44-32.55s0-3.36,1.77-3.99-12.98-4.62-12.98-4.62l-7.47,6.46,8.87,4.37s.63,32.55,0,35.59l-8.36-6.65s-.44-42.5.32-52.06l5.51-14.38s-10.96,6.21-12.67,10.01L0,11.66Z"/></svg>';

  const add = (host, key, className) => {
    if (!host || host.querySelector(`[data-bn-home-monogram="${key}"]`)) return;
    host.classList.add('bn-home-monogram-host');
    const mark = document.createElement('span');
    mark.className = `bn-home-monogram ${className}`;
    mark.dataset.bnHomeMonogram = key;
    mark.setAttribute('aria-hidden', 'true');
    mark.innerHTML = svg;
    host.appendChild(mark);
  };

  const boot = () => {
    add(document.querySelector('[id$="__bnv2_drop"] .bn-drop-live'), 'drop', 'bn-home-monogram--drop');
    add(document.querySelector('[id$="__bnv2_why"] .bnv2-section'), 'why', 'bn-home-monogram--why');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once:true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
